import { array, bool, func, string } from "prop-types";

import AnimateHeight from "react-animate-height";
import Checkbox from "../Checkbox/Checkbox.jsx";
import cx from "classnames";
import useMatchMedia from "../../common/useMatchMedia.js";
import { useRef } from "react";

const propTypes = {
  facets: array,
  onFacetClick: func,
  facetMenuOpen: bool,
  setFacetMenuOpen: func,
  showFacetsLabel: string,
};

const Facets = (props) => {
  const {
    facets,
    onFacetClick,
    facetMenuOpen,
    setFacetMenuOpen,
    showFacetsLabel,
  } = props;

  const matchesMobile = useMatchMedia("(max-width: 680px)");

  const ref = useRef();

  const renderChildGroup = (group, facetId) => {
    if (group.childGroups && group.childGroups.length > 0) {
      return (
        <div key={group.id}>
          {group.childGroups.map((subGroup, i) => (
            <div key={subGroup.id}>
              <div className="facet__group-label">{group.label}:</div>
              <div className="facet__sub-group">
                {renderChildGroup(subGroup)}
              </div>
            </div>
          ))}
        </div>
      );
    } else if (group.values && group.values.length > 0) {
      return (
        <div key={group.id} className="facet__sub-group">
          <div className="facet__group-label">{group.label}:</div>
          <ul className="facet__value-list">
            {group.values.map((value, i) => renderValue(value, facetId))}
          </ul>
        </div>
      );
    } else {
      return null;
    }
  };

  const renderValue = (value, facetId) => {
    return (
      <li className="facet__value" key={value.id}>
        <Checkbox
          onClick={() => onFacetClick(facetId, value.id)}
          checked={value.selected}
        >
          {value.name}
        </Checkbox>
      </li>
    );
  };

  const renderFacet = (facet) => {
    if (facet.childGroups && facet.childGroups.length > 0) {
      return (
        <div className="facet__group-wrapper">
          {facet.childGroups.map((group, i) =>
            renderChildGroup(group, facet.id)
          )}
        </div>
      );
    } else if (facet.values && facet.values.length > 0) {
      return (
        <ul className="facet__value-list">
          {facet.values.map((value, i) => renderValue(value, facet.id))}
        </ul>
      );
    } else {
      return null;
    }
  };

  return (
    <div
      ref={ref}
      className={cx("facets", "container", {
        "facets--open": facetMenuOpen,
        "container--bleed": matchesMobile,
      })}
    >
      {facets && facets.length > 0 && (
        <>
          <div className="facets__btn-container">
            <button
              className="facets__toggle call-to-action call-to-action--outline"
              type="button"
              onClick={(event) => {
                setFacetMenuOpen(!facetMenuOpen);
                event.target.blur();
              }}
            >
              {showFacetsLabel} <span className="icon">+</span>
            </button>
          </div>
          <AnimateHeight height={facetMenuOpen ? "auto" : 0}>
            <div className="facets__menu">
              {facets.map((facet, i) => (
                <div className="facet__group" key={facet.id}>
                  {facet.id !== "topics" && (
                    <div className="facet__label">{facet.label}</div>
                  )}
                  {renderFacet(facet)}
                </div>
              ))}
            </div>
          </AnimateHeight>
        </>
      )}
    </div>
  );
};

Facets.propTypes = propTypes;
export default Facets;
